module.exports = __webpack_public_path__ + "img/brands-barilla-flour.jpg?f7ea1a0b29882ba423d12fcda7ce61d6";